import { Button } from "@mui/material";
import { useThemeContext } from "./ThemeContext";



export default function ToggleTheme() {
    const { theme, toggleTheme } = useThemeContext();
    const swap = _theme => {
        return _theme === "dark" ? "light" : "dark";
    };

    return (
        <Button
            color="secondary"
            sx={{ my: 2, color: theme.mode === 'dark' ? 'white' : 'black', display: 'block' }}
            onClick={e => {
                const newMode = swap(theme.mode);
                toggleTheme(newMode);
            }}
        >
            {theme.mode}
        </Button>
    );
}